import React, { useState } from 'react'
import { canvasApi } from '@edulastic/api'
import { connect } from 'react-redux'
import { IconCanvas } from '@edulastic/icons'
import { notification } from '@edulastic/common'
import { roleuser } from '@edulastic/constants'
import { canvasBaseColor } from '@edulastic/colors'
import {
  getCanvasAllowedInstitutionPoliciesSelector,
  getRosterSourcedId,
  getUser,
  getUserOrgId,
  hasCanvasAccessToken,
  isCanvasDistrictSelector,
} from '../../../selectors/user'
import authorizeCanvas from '../../../../../common/utils/CanavsAuthorizationModule'
import { StyledTooltip } from '../../../../Reports/components/dataWarehouseReport/common/components/StyledComponents'
import { AuthorizeCanvasBtn } from './styled'

const CanvasAuthorization = ({
  user,
  canvasAllowedInstitutions,
  userDistrictId,
  canvasAccessToken,
  profileButton = false,
  fontSize,
  isOneRosterDistrict,
  isCanvasDistrict,
}) => {
  const [loading, setLoading] = useState(false)
  const handleCanvasAuthorization = async () => {
    try {
      setLoading(true)
      let result
      if (user.role === roleuser.TEACHER) {
        result = await canvasApi.getCanvasAuthURI(
          canvasAllowedInstitutions?.[0]?.institutionId
        )
      } else {
        result = await canvasApi.getCanvasAuthURI('', 'admin')
      }
      if (!result.userAuthenticated) {
        const subscriptionTopic = `canvas:${userDistrictId}_${user._id}_${
          user.username || user.email || ''
        }`
        authorizeCanvas(result.canvasAuthURL, subscriptionTopic).then(() => {
          notification({
            type: 'success',
            msg:
              'Your Canvas account is now connected. You’re all set to sync assignments and grades.',
          })
        })
      }
    } catch (err) {
      notification({
        type: 'error',
        msg: 'Canvas connection failed.',
      })
    } finally {
      setLoading(false)
    }
  }
  const isAdminUser = [roleuser.DISTRICT_ADMIN, roleuser.SCHOOL_ADMIN].includes(
    user.role
  )
  const allowCanvasLogin =
    isOneRosterDistrict &&
    isCanvasDistrict &&
    !canvasAccessToken &&
    (!isAdminUser ? canvasAllowedInstitutions?.length : true)

  // Don't render the button for below conditions
  if (!allowCanvasLogin) {
    return null
  }

  return (
    <StyledTooltip
      title="Connect your Canvas account to post assignments and grades from Pear Assessment"
      placement="bottom"
    >
      <AuthorizeCanvasBtn
        data-cy="authorize-canvas"
        type="link"
        onClick={handleCanvasAuthorization}
        loading={loading}
        borderColor={profileButton ? canvasBaseColor : ''}
        fontSize={fontSize}
      >
        {!loading && <IconCanvas height="16px" width="16px" />}
        Connect Canvas Account
      </AuthorizeCanvasBtn>
    </StyledTooltip>
  )
}

const enhance = connect((state) => ({
  user: getUser(state),
  userDistrictId: getUserOrgId(state),
  canvasAllowedInstitutions: getCanvasAllowedInstitutionPoliciesSelector(state),
  canvasAccessToken: hasCanvasAccessToken(state),
  isOneRosterDistrict: getRosterSourcedId(state),
  isCanvasDistrict: isCanvasDistrictSelector(state),
}))

export default enhance(CanvasAuthorization)
